export const industryNestedRoutes = [
  {
    id: 1,
    link: "/industry/agriculture",
    label: "Agriculture",
  },
  {
    id: 2,
    link: "/industry/solar-alternative-energy",
    label: "Solar & Alternative Energy",
  },
  {
    id: 3,
    link: "/industry/smart-homes",
    label: "Smart Homes",
  },
  {
    id: 4,
    link: "/industry/software-apps",
    label: "Software & Apps",
  },
  {
    id: 5,
    link: "/industry/digital-marketing",
    label: "Digital Marketing",
  },
];
